export const LICENCE_TYPES = [
  { id: "Support + Security + Email", name: "Support + Security + Email (£15 pm)", billingType: "recurring", billingFrequency: "monthly", monthlyRate: 15 },
  { id: "Support + Security + 365", name: "Support + Security + 365 (£30 pm)", billingType: "recurring", billingFrequency: "monthly", monthlyRate: 30 },
];
